var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChevronRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 12,
    viewBox: "0 0 6 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.749344 11.2913C0.650803 11.2918 0.553155 11.2725 0.462143 11.2347C0.371131 11.197 0.288589 11.1414 0.219345 11.0713C0.0788946 10.9307 0 10.74 0 10.5413C0 10.3425 0.0788946 10.1519 0.219345 10.0113L4.21935 6.01129L0.219345 2.01129C0.0868651 1.86911 0.014745 1.68105 0.0181732 1.48675C0.0216014 1.29245 0.100304 1.10707 0.237717 0.96966C0.37513 0.832247 0.560521 0.753545 0.754822 0.750117C0.949123 0.746689 1.13717 0.818809 1.27934 0.951289L5.77934 5.45129C5.91979 5.59191 5.99869 5.78254 5.99869 5.98129C5.99869 6.18004 5.91979 6.37066 5.77934 6.51129L1.27934 11.0113C1.21542 11.0923 1.13524 11.1591 1.04396 11.2074C0.952684 11.2556 0.85233 11.2842 0.749344 11.2913Z",
    fill: "#6B11C9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevron-right.7d13c51456cee909afc8cee096c270ec.svg";
export { ForwardRef as ReactComponent };